import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import { cfPath } from '../../utilities/UrlPaths';
import { invalidAccessTooltipText } from '../../utilities/BusinessLogic';

const PendingApprovalLink = ({
  accessCustomer,
  groupID,
  pendingApprovalsCount
}) => {
  const pendingApprovalText = pendingApprovalsCount === 1 ? 'Pending Approval' : 'Pending Approvals';
  const pendingApprovalsURL = accessCustomer
    ? `${cfPath()}/al/bidders/viewBidders.cfm?groupID=${groupID}`
    : null;

  return (
    <a
      id={`pendingApprovalLink_${groupID}`}
      className={`${
        accessCustomer ? 'link-secondary px-2' : 'link-disabled-white px-2'
      }`}
      href={pendingApprovalsURL}
    >
      {pendingApprovalsCount} {pendingApprovalText}
      {!accessCustomer && (
        <UncontrolledTooltip
          placement="left"
          target={`pendingApprovalLink_${groupID}`}
        >
          {invalidAccessTooltipText}
        </UncontrolledTooltip>
      )}
    </a>
  );
};

export default PendingApprovalLink;
